export default __webpack_public_path__ + "static/Products_Placeholder_3.0@2x-6fbc931be1becff78d4fd50954772091.jpg";